import React from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import { coverProcessingFeeToggle, recalculatePaymentFee, recalculateRecurringPaymentFee } from '../reducer';

import CheckboxWithDescription from '../../../components/common/checkboxWithDescription';

import { isLoading } from '../../../constants/loading';

export class CoverFeeView extends React.Component {

    componentDidMount() {
        if (this.props.amount) {
            this.changePaymentFee(this.props.coverProcessingFee);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.amount !== prevProps.amount) {
            this.changePaymentFee(this.props.coverProcessingFee);
        }
    }

    changePaymentFee = (coverFee) => {
        const amount = this.props.amount ? this.props.amount : 0;
        if (this.props.isRecurring) {
            this.props.recalculateRecurringPaymentFee(this.props.primaryPath, amount, coverFee);
        } else {
            this.props.recalculatePaymentFee(this.props.primaryPath, this.props.secondaryPath, amount, coverFee);
        }
    }

    onCoverProcessingFeeToggle = () => {
        const coverFee = !this.props.coverProcessingFee;
        this.changePaymentFee(coverFee);
        this.props.onCoverFeeToggle(coverFee);
    }

    render() {
        return (
            <React.Fragment>
                {
                    !this.props.hideCoverFee &&
                    <CheckboxWithDescription
                        className="cover-fee"
                        checked={this.props.coverProcessingFee}
                        onChange={this.onCoverProcessingFeeToggle}
                        disabled={this.props.fetchingFeeInProgress || isLoading(this.props.paymentInProgress)}
                        label={(
                            <label className="info-included">
                                {"Cover the donation processing fee"}
                            </label>
                        )}
                        description={this.props.coverProcessingFee && "Thank you! This keeps our technology free"} />
                }
            </React.Fragment>
        )
    }
}

const mapState = (state, _ownProps) => {
    return {
        coverProcessingFee: state.donation.coverProcessingFee,
        fetchingFeeInProgress: state.donation.fetchingFeeInProgress,
        paymentInProgress: state.donation.paymentInProgress,
        primaryPath: state.page.primaryPath,
        secondaryPath: state.page.secondaryPath,
        isRecurring: get(state, 'donation.subscription.enabled'),
        hideCoverFee: get(state, 'donation.hideCoverFee')
    }
}

const mapDispatch = (dispatch) => {
    return {
        onCoverFeeToggle: (coverFee) => {
            dispatch(coverProcessingFeeToggle(coverFee));
        },
        recalculatePaymentFee: (primaryPath, secondary, amount, coverFee) => {
            dispatch(recalculatePaymentFee(primaryPath, secondary, amount, coverFee))
        },
        recalculateRecurringPaymentFee: (primaryPath, amount, coverFee) => {
            dispatch(recalculateRecurringPaymentFee(primaryPath, amount, coverFee))
        }
    };
};

const CoverFee = withRouter(connect(mapState, mapDispatch)(CoverFeeView));
export default CoverFee;